import { axiosClient } from "@/shared/api/axios-client";
import type { RolAdmin } from "@/features/admin-roles/services/roles-service";

/** Estado de un módulo para un usuario (override sobre lo heredado del rol). */
export type EstadoModulo = "Heredar" | "Otorgar" | "Bloquear";

/** Un módulo (permiso) visto para un usuario: herencia de rol + override + efecto. */
export interface ModuloDeUsuario {
  codigo: string;
  grupo: string;
  descripcion: string;
  heredadoDeRol: boolean;
  override: EstadoModulo;
  efectivo: boolean;
}

/** Restablece los módulos de un rol de SISTEMA a su default de código. */
export async function restablecerPermisosDeRol(id: string): Promise<RolAdmin> {
  const { data } = await axiosClient.post<RolAdmin>(`/api/admin/roles/${id}/restablecer-permisos`);
  return data;
}

/** Lista los módulos de un usuario con su estado (heredado/override/efectivo). */
export async function listarModulosDeUsuario(usuarioId: string): Promise<ModuloDeUsuario[]> {
  const { data } = await axiosClient.get<ModuloDeUsuario[]>(`/api/admin/usuarios/${usuarioId}/modulos`);
  return data;
}

/** Fija el override de un módulo para un usuario (Heredar quita el override). */
export async function establecerModuloDeUsuario(
  usuarioId: string,
  permisoCodigo: string,
  estado: EstadoModulo
): Promise<void> {
  await axiosClient.put(`/api/admin/usuarios/${usuarioId}/modulos`, { permisoCodigo, estado });
}
